import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { _throw } from 'rxjs/observable/throw';
import { timer } from 'rxjs/observable/timer';
import { retry, catchError, mergeMap } from 'rxjs/operators';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log('Error in interceptor:', error);
        if (error.message.includes('ERR_SOCKET_NOT_CONNECTED') || error.message.includes('ERR_CONNECTION_RESET') || error.message.includes('Http failure response for (unknown url): 0 Unknown Error') || error.message.includes('Unknown Error')) {
          return timer(1000).pipe(
            mergeMap(() => next.handle(req))
          );
        }
        return _throw(error);
      })
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/retry.interceptor.ts